import React from 'react'
import styled from 'styled-components'
import Text from 'ui/acro/typography/Text'

const Wrapper = styled('div')({
  width: '100%',
  marginBottom: '12px'
})

const Bar = styled('div')({
  width: '100%',
  height: '6px',
  background: '#ccc',
  borderRadius: '999px',
  overflow: 'hidden'
})

const Fill = styled.div`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  background: #3b3b3b;
  transition: width 0.4s ease;
`

const ChartDetails = styled(Text)({
  marginTop: '6px',
  marginBottom: '8px',
  fontSize: '16px',
  fontWeight: 500,
  color: '#000',
  fontFamily: 'Proxima-nova',
  lineHeight: '135%',
  letterSpacing: '0.8px',
  textTransform: 'uppercase'
})

const LinearProgressChart = ({ totalClasses, completedClasses, showText }) => {
  const safeTotal = totalClasses || 1

  const percentage = Math.min((completedClasses / safeTotal) * 100, 100)

  return (
    <Wrapper>
      {showText && (
        <ChartDetails>
          {completedClasses} of {totalClasses} completed
        </ChartDetails>
      )}

      <Bar>
        <Fill percentage={percentage} />
      </Bar>
    </Wrapper>
  )
}

export default LinearProgressChart
